import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import env from 'Env';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import { ScriptTag } from 'Helpers/SEO/Tags';

const messages = defineMessages({
  home: {
    id: 'breadcrumbs.home',
    defaultMessage: 'Home',
  },
});

const Breadcrumbs = ({ crumbs, intl: { formatMessage }, appearsOn }) => {
  if (!crumbs || !crumbs.length) {
    return false;
  }

  const home = {
    label: formatMessage(messages.home),
    link: '/',
  };

  let fullUrl = window.location.href.split('?')[0];

  if (getUrlParameter('page')) {
    fullUrl = `${fullUrl}?page=${getUrlParameter('page')}`;
  }

  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${fullUrl}#breadcrumb`,
    itemListElement: crumbs.filter(c => c.link).map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.label,
      item: env.enhanceItemLists ? {
        name: crumb.label,
        type: 'WebPage',
        '@id': crumb.link ? `https://${env.appUrl}/${window.locale || 'en'}${crumb.link}#webpage` : undefined,
      } : `https://${env.appUrl}/${window.locale || 'en'}${crumb.link}`,
    })),
  });

  try {
    return ReactDOM.createPortal(
      <div className={classNames(`site-breadcrumbs ${appearsOn}`)}>
        <ScriptTag id="breadcrumbs-schema" type="application/ld+json" script={schema} />
        <div className="container">
          <Breadcrumb>
            {[home, ...crumbs].map((crumb, i) =>
              <React.Fragment key={crumb.link}>
                {i > 0 && <FontAwesomeIcon icon={faChevronRight} />}
                {(i === crumbs.length || !crumb.link) ?
                  <BreadcrumbItem active>{crumb.label}</BreadcrumbItem> :
                  <BreadcrumbItem><Link to={crumb.link}>{crumb.label}</Link></BreadcrumbItem>
                }
              </React.Fragment>,
            )}
          </Breadcrumb>
        </div>
      </div>,
      document.getElementById('footer-breadcrumbs'),
    );
  } catch (e) {
    return <ScriptTag id="breadcrumbs-schema" type="application/ld+json" script={schema} />;
  }
};

export default injectIntl(Breadcrumbs);

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string,
  })).isRequired,
  appearsOn: PropTypes.string,
};

Breadcrumbs.defaultProps = {
  appearsOn: '',
};
